/* eslint-disable react/no-unused-state,react/no-unescaped-entities */
import React, { memo, useEffect } from "react";
import { Card, CardBody, Col } from "reactstrap";
import DataTable from "../../../../shared/components/DataTable";
import { connect } from "react-redux";
import ActivityLogSearchForm from "./ActivityLogSearchForm.js";

import { permissionsConstants } from "../../../../constants/permissions.constants";
import AccessControl from "../../../../shared/components/AccessControl";
import {
  csvResetActivityLogDownload,
  downloadCsvActivityLog,
  downloadPdfActivityLog,
  getActivityLog,
  pdfResetActivtyLogDownload,
  resetStatements,
} from "../../actions/getActivityLog.actions";

const ActivityLogTable = memo(
  ({
    permissions,
    dispatch,
    activityLogStatement,
    pdfFormatDownload,
    csvFormatDownload,
  }) => {
    const count =
      activityLogStatement && activityLogStatement.response
        ? activityLogStatement.response.count
        : 0;

    const activityLogData =
      activityLogStatement && activityLogStatement.response
        ? activityLogStatement.response.content
        : [];

    const columns = [
      {
        accessor: "issuerName",
        name: "Issuer Name",
        sortable: true,
        filterable: true,
        sortKey: "issuerName",
      },
      {
        accessor: "username",
        name: "User Name",
        sortable: true,
        filterable: true,
        sortKey: "username",
        Cell: (row) => <span>{row.username.replace(".", " ").trim()}</span>,
      },
      {
        accessor: "userLogin",
        name: "User Login",
        sortable: true,
        sortKey: "userLogin",
      },
      {
        accessor: "activityTitle",
        name: "Affected Activity",
        sortable: true,
        sortKey: "activityTitle",
      },
      {
        accessor: "time",
        name: "Time",
        sortable: true,
        sortKey: "time",
      },
      {
        accessor: "date",
        name: "Date",
        sortable: true,
        sortKey: "date",
      },
    ];

    const getActivityLogStatement = (values) => {
      dispatch(getActivityLog(values));
    };

    const handleDownload = (fileType) => {
      if (fileType === "CSV") {
        dispatch(
          downloadCsvActivityLog({
            ...activityLogStatement.request,
            download: true,
            fileType: fileType,
          })
        );
      }

      if (fileType === "PDF") {
        dispatch(
          downloadPdfActivityLog({
            ...activityLogStatement.request,
            download: true,
            fileType: fileType,
          })
        );
      }
    };

    const loadData = (page, pageSize) => {
      dispatch(
        getActivityLog({
          ...activityLogStatement.request,
          page: page,
          pageSize: pageSize,
        })
      );
    };

    useEffect(() => {
      getActivityLogStatement({ page: 1, pageSize: 10 });
    }, []);

    useEffect(() => {
      return () => {
        dispatch(resetStatements());
        dispatch(csvResetActivityLogDownload());
        dispatch(pdfResetActivtyLogDownload());
      };
    }, [dispatch]);
    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <ActivityLogSearchForm
              loading={activityLogStatement && activityLogStatement.loading}
              onSubmit={getActivityLogStatement}
              activityLogStatement={activityLogStatement}
              csvFormatDownload={csvFormatDownload}
              pdfFormatDownload={pdfFormatDownload}
              handleDownload={handleDownload}
            />

            <AccessControl
              allowedPermissions={[permissionsConstants.FETCH_ISSUER_CONFIGS]}
              renderNoAccess={() => (
                <DataTable
                  columns={columns.slice(1)}
                  loading={activityLogStatement && activityLogStatement.loading}
                  data={activityLogData}
                  permissions={permissions}
                  NoDataText={
                    activityLogStatement && activityLogStatement.response
                      ? "No transaction(s) found"
                      : "Please enter search criteria"
                  }
                  count={count}
                  loadData={loadData}
                  countName="activities"
                  defaultPageSize={10}
                  defaultPageNumber={1}
                  error={activityLogStatement && activityLogStatement.error}
                  bordered={true}
                  striped={true}
                  hover={true}
                  responsive
                  serverside
                />
              )}
            >
              <DataTable
                columns={columns}
                loading={activityLogStatement && activityLogStatement.loading}
                data={activityLogData}
                permissions={permissions}
                NoDataText={
                  activityLogStatement && activityLogStatement.response
                    ? "No transaction(s) found"
                    : "Please enter search criteria"
                }
                count={count}
                loadData={loadData}
                countName="activities"
                defaultPageSize={10}
                defaultPageNumber={1}
                error={activityLogStatement && activityLogStatement.error}
                bordered={true}
                striped={true}
                hover={true}
                responsive
                serverside
              />
            </AccessControl>
          </CardBody>
        </Card>
      </Col>
    );
  }
);

export default connect((state) => ({
  permissions: state.permissions && state.permissions.response,
  activityLogStatement: state.activityLog,
  csvFormatDownload: state.downloadActivityLog,
  pdfFormatDownload: state.pdfDownloadActivityLog,
}))(ActivityLogTable);
